import { AssetService, UtilsService } from '@/services';

import { isValueExist } from '@util';

import { CONNECTION_TYPES } from '@consts';

const { GA, FB_APP, FB_PAGE, PIXEL, YOUTUBE_CHANNEL } = CONNECTION_TYPES;

const makeConnectionGetter = (type) =>
    R.compose(R.defaultTo([]), R.path(['connectionMap', type]), R.nthArg(1));

export default {
    namespaced: true,
    state: {
        connections: undefined,
        gaEmails: [
            'analytics2-10@seventh-country-251404.iam.gserviceaccount.com',
            'adrielanalytics2@gmail.com',
        ],
    },
    mutations: {
        setConnections(state, data = []) {
            state.connections = Object.freeze(data);
        },
        setGaEmails(state, data = []) {
            if (!isValueExist(data) || !Array.isArray(data)) {
                return;
            }

            state.gaEmails = data;
        },
    },
    actions: {
        fetchAssets(
            { commit, dispatch },
            { token = '', hasLoading = false, accountId = '' } = {}
        ) {
            if (hasLoading) {
                dispatch(
                    'view/setLoadingAdriel',
                    { active: true, message: ' ' },
                    { root: true }
                );
            }
            return AssetService.list({ accountId, token })
                .then((ret) => {
                    commit('setConnections', Object.freeze(ret));
                    return ret;
                })
                .catch(console.log)
                .finally(() => {
                    if (hasLoading) {
                        dispatch(
                            'view/setLoadingAdriel',
                            { active: false, message: ' ' },
                            { root: true }
                        );
                    }
                });
        },
        deleteAdAccounts({ dispatch }, { token, id, cAccountId }) {
            return AssetService.newDeleteDatastream({
                token,
                id,
            }).then(() =>
                dispatch('fetchAssets', { token, accountId: cAccountId })
            );
        },
        fetchGaEmails({ commit }) {
            return UtilsService.fetchGaEmails().then((data) => {
                commit('setGaEmails', data);
            });
        },
    },
    getters: {
        connectionMap: R.compose(
            R.map(R.sortBy(R.prop('id'))),
            R.groupBy(R.prop('type')),
            R.prop('connections')
        ),
        connectionMapById: R.compose(
            R.indexBy(R.prop('id')),
            R.prop('connections')
        ),
        gaConnections: makeConnectionGetter(GA),
        pixelConnections: makeConnectionGetter(PIXEL),
        fbAppConnections: makeConnectionGetter(FB_APP),
        fbPageConnections: makeConnectionGetter(FB_PAGE),
        youTubeChannelConnections: makeConnectionGetter(YOUTUBE_CHANNEL),
        connections: R.prop('connections'),
    },
};
